import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import './assets/icons/icomoon/styles.min.css'

createApp(App).mount('#app')